/**
 * Mobile menu for the Elementor "Header" template (full screen, option A): the burger button opens
 * and closes #ssf-menu, which fills the window below the header. While it is open the page does not
 * scroll, Tab stays inside the menu and the burger, and Esc closes it.
 *
 * @package Sitamaa_Sahayata_Foundation
 */

( function () {
	'use strict';

	var toggle = document.querySelector( '.ssf-menu-toggle .elementor-button' );
	var menu = document.getElementById( 'ssf-menu' );

	if ( ! toggle || ! menu ) {
		return;
	}

	var root = document.documentElement;
	var header = toggle.closest( '.ssf-header' ) || menu.parentElement;
	var desktop = window.matchMedia( '(min-width: 1025px)' );
	var closing = 0;

	toggle.setAttribute( 'role', 'button' );
	toggle.setAttribute( 'aria-controls', menu.id );
	toggle.setAttribute( 'aria-expanded', 'false' );

	function isOpen() {
		return menu.classList.contains( 'is-open' );
	}

	// The menu starts where the header ends; the header is shorter once the page has scrolled.
	function place() {
		var bottom = header.getBoundingClientRect().bottom;
		root.style.setProperty( '--ssf-menu-top', Math.max( 0, Math.round( bottom ) ) + 'px' );
	}

	function setOpen( open ) {
		if ( open === isOpen() ) {
			return;
		}
		if ( open ) {
			place();
		}
		menu.classList.toggle( 'is-open', open );
		root.classList.toggle( 'ssf-menu-open', open );
		// Keep the header without its blur until the menu has faded out (see style.css).
		window.clearTimeout( closing );
		root.classList.toggle( 'ssf-menu-closing', ! open );
		if ( ! open ) {
			closing = window.setTimeout( function () {
				root.classList.remove( 'ssf-menu-closing' );
			}, 320 );
		}
		toggle.setAttribute( 'aria-expanded', String( open ) );
		if ( open ) {
			menu.scrollTop = 0;
		}
	}

	function focusables() {
		return [ toggle ].concat( Array.prototype.slice.call( menu.querySelectorAll( 'a[href], input, button' ) ) );
	}

	toggle.addEventListener( 'click', function ( event ) {
		event.preventDefault();
		setOpen( ! isOpen() );
	} );

	// The toggle is a link styled as a button, so give it the Space key a button has.
	toggle.addEventListener( 'keydown', function ( event ) {
		if ( ' ' === event.key ) {
			event.preventDefault();
			setOpen( ! isOpen() );
		}
	} );

	menu.addEventListener( 'click', function ( event ) {
		if ( event.target.closest( 'a' ) ) {
			setOpen( false );
		}
	} );

	document.addEventListener( 'keydown', function ( event ) {
		if ( ! isOpen() ) {
			return;
		}
		if ( 'Escape' === event.key ) {
			setOpen( false );
			toggle.focus();
			return;
		}
		if ( 'Tab' === event.key ) {
			var items = focusables();
			var first = items[ 0 ];
			var last = items[ items.length - 1 ];
			if ( event.shiftKey && document.activeElement === first ) {
				event.preventDefault();
				last.focus();
			} else if ( ! event.shiftKey && document.activeElement === last ) {
				event.preventDefault();
				first.focus();
			} else if ( items.indexOf( document.activeElement ) === -1 ) {
				event.preventDefault();
				first.focus();
			}
		}
	} );

	window.addEventListener( 'resize', function () {
		if ( isOpen() ) {
			place();
		}
	} );

	desktop.addEventListener( 'change', function ( event ) {
		if ( event.matches ) {
			setOpen( false );
		}
	} );
}() );

/**
 * Condensed header: once the page scrolls, <html> gets "ssf-stuck" and style.css shrinks the header
 * to the logo's icon. Two thresholds (on at 120px, off at 40px) stop the header flickering, since
 * the shrink itself moves the page by the height it loses.
 */
( function () {
	'use strict';

	if ( document.body.classList.contains( 'elementor-editor-active' ) ) {
		return;
	}

	var root = document.documentElement;
	var stuck = false;
	var ticking = false;

	function update() {
		var y = window.scrollY || window.pageYOffset;
		var next = stuck ? y > 40 : y > 120;
		if ( next !== stuck ) {
			stuck = next;
			root.classList.toggle( 'ssf-stuck', stuck );
		}
		ticking = false;
	}

	window.addEventListener( 'scroll', function () {
		if ( ! ticking ) {
			ticking = true;
			window.requestAnimationFrame( update );
		}
	}, { passive: true } );

	update();
}() );

/**
 * Hero height on desktop: `.section-hero` fills the window below everything above it (admin bar,
 * header, Warli strip). The distance is measured here into --ssf-above-hero, so it stays right when
 * the header changes; style.css falls back to 132px before this runs. Measured only with the header
 * at full size (not shrunk by scrolling).
 */
( function () {
	'use strict';

	var hero = document.querySelector( '.section-hero' );

	if ( ! hero ) {
		return;
	}

	var root = document.documentElement;

	function measure() {
		if ( root.classList.contains( 'ssf-stuck' ) ) {
			return;
		}
		var top = hero.getBoundingClientRect().top + ( window.scrollY || window.pageYOffset );
		root.style.setProperty( '--ssf-above-hero', Math.round( top ) + 'px' );
	}

	measure();
	window.addEventListener( 'resize', measure, { passive: true } );
	window.addEventListener( 'load', measure );
	if ( document.fonts && document.fonts.ready ) {
		document.fonts.ready.then( measure );
	}
}() );
